import apiConfig from "../ApiConfig";

// Fetch all active frameworks from framework_master collection
export const fetchFrameworkMasterApi = async () => {
  try {
    const response = await apiConfig.get("/api/trust-center/framework-master/");
    const frameworks = response.data?.frameworks || [];
    console.log("📊 Raw API Response (frameworks):", frameworks);
    const mapped = frameworks.map((fw) => ({
      _id: fw.id,
      name: fw.name,
      category: fw.category,
    }));
    console.log("✅ Mapped frameworks:", mapped);
    return mapped;
  } catch (error) {
    console.error("Error fetching framework master list:", error);
    throw error;
  }
};

// Fetch Trust Center toggle states for a customer from customer_requirements
export const fetchTrustCenterFrameworkTogglesApi = async (customerId) => {
  try {
    const response = await apiConfig.get(
      `/api/ai-crm/api/v1/customer-requirements/${customerId}/?type=TrustCenter`
    );
    return response.data?.data || {};
  } catch (error) {
    console.error("Error fetching TrustCenter toggles:", error);
    return {};
  }
};

// Update a framework toggle in customer_requirements under type_structure.TrustCenter
export const updateTrustCenterFrameworkToggleApi = async (customerId, frameworkId, value) => {
  try {
    const response = await apiConfig.put(
      `/api/ai-crm/api/v1/customer-requirements/update_requirement/`,
      {
        customer_id: customerId,
        type: "TrustCenter",
        field: frameworkId,
        value,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating TrustCenter framework toggle:", error);
    throw error;
  }
};


export const uploadArtifactDocumentApi = async (formData) => {
  try {
    const res = await apiConfig.post(
      `/api/customer-framework/upload-document-file/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getCustomerDocumentFileApi = async (documentId) => {
  try {

    const response = await apiConfig.get(`api/customer-framework/get-document-file/${documentId}/`)
    return response;
  } catch (error) {
    throw error;
  }
};